import React, { useState, useEffect } from 'react';
import { Hero } from '../../components/sections/heroSection/Hero';
import { Box, Button } from '@mui/material';
import WorkSection from '../../components/sections/workSection/WorkSection';
import Footer from '../../components/footer/Footer';
import TestimonialCarousel from '../../components/sections/testimonialSection/Testimonial';
import PricingPlans from '../../components/sections/planSection/Plan';
import MissionStatements from '../../components/sections/missionStatements/MissionStatements';
import Features from '../../components/sections/featureSection/Feature';
import AICard from '../../components/sections/aiCard/AICard';
import { theme } from '../../theme/theme';
import FAQSection from '../../components/sections/FAQ/FAQ';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import LoginSignupModal from '../../components/login/Login';
import { ArrowUpward } from '@mui/icons-material';

const Home = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <Helmet>
        <title>{t('title_home')}</title>
      </Helmet>
      <Box sx={{ maxWidth: '100%' }}>
        <LoginSignupModal open={open} onClose={() => setOpen(false)} />
        <Hero handleClickOpen={handleClickOpen} />
        <WorkSection id="how-it-works" title={t('🛠️ How It Works')} />
        <AICard
          background={theme.palette.aiCard.blue}
          buttonColor={'#1f2d5c'}
          elementColor={theme.palette.aiCard.darkBlue}
          textColor={'white'}
        />
        <Features id="features" title={t('Features')} />
        <TestimonialCarousel id="testimonials" />
        <PricingPlans id="pricing" />
        <MissionStatements />
        <FAQSection />
        <Footer id="contact-us" />
      </Box>
      <Button
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 100,
          opacity: isVisible ? '70%' : 0,
          visibility: isVisible ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease, visibility 0.3s ease',
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            opacity: '100%'
          }
        }}
        variant="contained">
        <ArrowUpward sx={{ fontSize: '32px' }} />
      </Button>
    </>
  );
};

export default Home;
